export default __webpack_public_path__ + "static/Keep tabs on how much work each team has done@2x-c6481fefd0d9f507a5257dec3811cb9b.png";